import React, { useEffect, useState } from 'react'
import './PopupAd.css'

import standingsKnapperAd from '../../images/ads/popupKnapperAd.png'

const PopupAd = ({ isInApp }) => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)
	const [isOpen, setIsOpen] = useState(false)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)

		return () => window.removeEventListener('resize', handleResize)
	}, [])

	useEffect(() => {
		if (isMobile && !isInApp) {
			setIsOpen(true)
		} else {
			setIsOpen(false)
		}
	}, [isMobile, isInApp])

	if (!isOpen || !isMobile || isInApp) {
		return null
	}

	return (
		<div className='standingsPopupAdBackdrop'>
			<div
				className='standingsPopupAdModal'
				role='dialog'
				aria-modal='true'
				aria-label='Knapper advertisement'
			>
				<button
					type='button'
					className='standingsPopupAdClose'
					onClick={() => setIsOpen(false)}
					aria-label='Close advertisement'
				>
					&times;
				</button>

				<a
					href='https://knapperusa.com'
					target='_blank'
					rel='noopener noreferrer'
					className='standingsPopupAdLink'
				>
					<img
						src={standingsKnapperAd}
						alt='Knapper protective equipment promotion'
						className='standingsPopupAdImage'
					/>
				</a>
			</div>
		</div>
	)
}

export default PopupAd
